import { StorageService } from "@/services/nextshop/storage.service"

export default {
  methods: {
    async changeStatusOrder(orderID, currentStatus, newStatus) {
      try {
        const params = {
          currentStatus: currentStatus,
          newStatus: newStatus,
          orderId: orderID,
          reason : ""
        }

        const response = await StorageService.storageChangeStatus(params)

        if (response.success) {
          return response.data
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}